<form [formGroup]="ObservacionesGroupForm">
	<!-- Observaciones-->
	<div class="form-group mb-0">
		<!--<label for="observaciones">Observaciones</label>-->
		<textarea class="form-control" id="observaciones" rows="3" formControlName="observaciones" placeholder="Escriba aquí sus observaciones" maxlength="500"></textarea>
		<div class="text-right">
			<small class="text-muted">{{ ObservacionesGroupForm.get("observaciones").value?.length || 0 }} / 500 caracteres</small>
		</div>
	</div>
</form>
